
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {},
})
export default class FavoriteBtn extends Vue {
    @Prop() isFavorite!: boolean;
    @Prop() event!: (isFavorite: boolean) => {};
}
